import { render, staticRenderFns } from "./popup_sort.vue?vue&type=template&id=40a9dd4c&lang=pug"
import script from "./popup_sort.vue?vue&type=script&lang=js"
export * from "./popup_sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports